module.exports = __webpack_public_path__ + "static/media/MyProfile_Selected@3x.38d14c71.png";